import VueRouter from 'vue-router'
import routes from './routes'
import Vue from "vue";
import store from '../store'

const router = new VueRouter({
    mode: 'history',
    routes: routes,
    scrollBehavior (to, from, savedPosition) {
        return { x: 0, y: 0 }
    }
});
router.afterEach((to, from) => {
    Vue.nextTick(() => {
        document.title = `Fluxum | ${to.meta.title}`;
    });

    if (store.state.menu.isMenuOpen) {
        store.commit('menu/closeMenu');
    }
});

export default router;
